import React, { Component } from "react";
import Progress from "../../common/Progress";
import Input from "../../common/Input";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PictureUpload from "../../common/PictureUpload";
import API from "../../common/Api";

const mapStateToProps = (state) => ({
  locations: state.locations,
  business: state.business,
  businessCatergories: state.businessCatergories,
  headers: state.headers(),
  postOptions: state.postOptions,
  userProfile: state.userProfile,
});

export default connect(mapStateToProps)(
  class Onboarding extends Component {
    modal = React.createRef();
    state = {
      errors: {},
      isLoading: false,
    };
    next = (ev) => {
      ev.preventDefault();
      const form = ev.currentTarget;
      const loaded = () => this.setState({ isLoading: false });
      const body = {
        invitation_code: form.invitation_code.value,
      };
      this.setState({ isLoading: true, errors: {} });
      API.post("business/join", body, { headers: this.props.headers }).then(
        ({ data }) => {
          loaded();
          window.$.notify(data.message, "success-alert");
          if (data.success) {
            this.setState({ redirect: "/" });
          }
          this.updateProfilePicture(form);
        },
        ({ response }) => {
          loaded();
          const data = response.data;
          const raw_errors = data.errors;
          window.$.notify(data.message, "error-alert");
          let errors = {};
          raw_errors.map((err) => {
            errors[err.field] = err.message;
          });
          this.setState({ errors });
        }
      );
    };

    updateProfilePicture = (form) => {
      const body = new FormData(form);
      const requiredList = ["first_name", "last_name", "email", "phone_number"];
      requiredList.forEach((item) =>
        body.append(item, this.props.userProfile?.[item])
      );
      body.append("_method", "put");

      API({
        url: "profile",
        method: "POST",
        headers: {
          ...this.props.headers,
          Accept: "*/*",
        },
        data: body,
      }).then(({ data }) => {});
    };

    componentDidMount = () => {
      const query = new URLSearchParams(this.props.location.search);
      this.setState({ defaultCode: query.get("invite_code") });
    };

    render() {
      return (
        <div className="onboarding-page">
          {this.state.redirect ? <Redirect to={this.state.redirect} /> : ""}
          {this.props.business.identifier ? this.setState({ redirect: "/" }) : ""}

          <Progress total={2} current={2}>
            <h1 className="form-title dsk">Complete your profile</h1>
          </Progress>

          <div className="form_step form-page">
            <h1 className="form-title mbl">Complete your profile</h1>
            <div className="form-container">
              <form onSubmit={this.next}>
                <div>
                  <PictureUpload name="profile_picture" />
                  <Input
                    label="Business invite code"
                    name="invitation_code"
                    placeholder="Enter code here"
                    defaultValue={this.state.defaultCode}
                    type="text"
                    error={this.state.errors.invitation_code}
                    required
                  />
                  <div></div>
                  <div className="footer flex center space-btw">
                    <button
                      className={`default ${
                        this.state.isLoading ? "loading" : ""
                      }`}
                      type="submit"
                    >
                      Finish
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      );
    }
  }
);
